module.exports = __webpack_public_path__ + "assets/img/more_img_en.9ee72da6.jpg";